/**
 * Canonical display config for ApplicationStatus values.
 * Single source of truth — imported by all pages and layout components.
 */
import type { ApplicationStatus } from '@vedjegy/shared';

export interface ApplicationStatusConfig {
  label: string;
  /** Badge background color */
  bg:    string;
  /** Badge text color */
  text:  string;
}

export const APPLICATION_STATUS_CONFIG: Record<ApplicationStatus, ApplicationStatusConfig> = {
  draft:                      { label: 'Tervezet',                   bg: '#f1f5f9', text: '#64748b' },
  submitted:                  { label: 'Beküldve',                   bg: '#eff6ff', text: '#1d4ed8' },
  preq_under_review:          { label: 'Előmin. folyamatban',        bg: '#fef9e7', text: '#b07d00' },
  preq_passed:                { label: 'Előmin. sikeres',            bg: '#f0fdf4', text: '#166534' },
  preq_failed:                { label: 'Előmin. sikertelen',         bg: '#fef2f2', text: '#991b1b' },
  under_review:               { label: 'Bírálat alatt',              bg: '#f5f3ff', text: '#7c3aed' },
  deficiency_required:        { label: 'Hiánypótlás szükséges',      bg: '#fffbeb', text: '#b45309' },
  deficiency_submitted:       { label: 'Hiánypótlás beküldve',       bg: '#eff6ff', text: '#1d4ed8' },
  completed:                  { label: 'Lezárva',                    bg: '#f0fdf4', text: '#166534' },
  approved:                   { label: 'Elfogadva',                  bg: '#f0fdf4', text: '#166534' },
  rejected:                   { label: 'Elutasítva',                 bg: '#fef2f2', text: '#991b1b' },
  board_rejected:             { label: 'Elnökségi vétó',             bg: '#fdf2f8', text: '#86198f' },
  board_approved:             { label: 'Elnökségi jóváhagyás',       bg: '#f0fdf4', text: '#14532d' },
  pending_exclusion_review:   { label: 'Kizárás vizsgálatban',       bg: '#fffbeb', text: '#92400e' },
  excluded:                   { label: 'Kizárva',                    bg: '#fef2f2', text: '#7f1d1d' },
};

/** Convenience map — just the label strings. */
export const APPLICATION_STATUS_LABELS: Record<ApplicationStatus, string> = Object.fromEntries(
  (Object.entries(APPLICATION_STATUS_CONFIG) as [ApplicationStatus, ApplicationStatusConfig][])
    .map(([k, v]) => [k, v.label]),
) as Record<ApplicationStatus, string>;
